import * as i18next from 'i18next'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { Action, mk_widget, Widget } from 'widgets-for-react'
import { FooterState } from '../../../public_site.main.mod'
import { ExternalLink } from '../utils/external_link'
import { addLangToUrl, getLangFromHost, getLangFromUrl, updateUrlLang } from '../utils/history.mod'

export const footer: (_: FooterState) => Widget<Action<FooterState>> = (props) => {
  return mk_widget({
    run: (o) => {
      const lang = getLangFromUrl()
      const isNA = lang == "na" || lang == "na-fr" || lang == "na-es"
      const refrescoBranding = (props.node != 'none' && props.node.bundle == 'page' ? props.node.field_refresco_branding : false)
      
      return (
        !refrescoBranding ? (
          <Footer>
            <div className="footer__inner container container--m grid--gutter">
              <div className="footer__logo">
                <Link to={addLangToUrl('/')}>
                  <img src="/frontend/images/logo--tagline.svg" alt="Refresco's logo" />
                </Link>
              </div>
              <nav className="nav nav--footer">
                {/* Quicklinks */}
                {props.menu.kind == 'loaded' && (
                  <ul className="nav__list" id="a11y-footer-navigation">
                    {props.menu.value.map((menuItem) => (
                      <li className="nav__item">
                        {menuItem.url && (
                          <ExternalLink
                            type="link"
                            className="nav__link"
                            to={menuItem.url?.startsWith("http") || menuItem.url?.startsWith("www") ? menuItem.url : updateUrlLang(menuItem.url, lang)}
                          >
                            {menuItem.label}
                          </ExternalLink>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </nav>
              <div className="footer__copyright" id="a11y-footer-copyright">
                {/* Quicklinks */}
                {props.privacyMenu.kind == 'loaded' && (
                  <ul className="nav__list" id="a11y-footer-navigation">
                    <li className="nav__item nav__item--opace">
                      {isNA ? "® Refresco North America 2025" : lang == "uk" ? "® Refresco United Kingdom 2025" : i18next.t("footer:copyright")}
                    </li>
                    {props.privacyMenu.value.map((privacyItem) => (
                      <li className="nav__item nav__item--opace">
                        {privacyItem.url && (
                          <ExternalLink
                            type="link"
                            className="nav__link"
                            to={updateUrlLang(privacyItem.url, lang)}
                          >
                            {privacyItem.label}
                          </ExternalLink>
                        )}
                      </li>
                    ))}
                    <li className="nav__item nav__item--social">
                      <h2 className="footer__title text--l">{i18next.t("footer:linkedin_text")}</h2>
                      <a className="footer__social-link footer__social-link--linkedin" href="https://www.linkedin.com/company/refresco/" target="_blank"></a>
                      {socialMediaLink('na', 'facebook', 'https://www.facebook.com/RefrescoUSCareers')}
                      {socialMediaLink('global', 'instagram', 'https://www.instagram.com/refrescogroup')}
                      {socialMediaLink('nl', 'facebook', 'https://www.facebook.com/RefrescoBenelux')}
                      {socialMediaLink('fr', 'facebook', 'https://www.facebook.com/RefrescoFrance')}
                      {socialMediaLink('fr', 'instagram', 'https://www.instagram.com/refresco_france')}
                      {socialMediaLink('au', 'facebook', 'https://www.facebook.com/RefrescoAustralia')}
                      {socialMediaLink('au', 'instagram', 'https://www.instagram.com/refrescoaustralia')}
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </Footer>
        ) : (
          <Footer>
            <div className="footer__inner container container--m grid--gutter"></div>
          </Footer>
        )
      )
    }
  })
}
type FooterComponentState = {}

class Footer extends React.Component<FooterComponentState> {
  private raf: number
  private footerRef: HTMLElement
  private scrollStartTime = 0
  private scrollStartY = 0

  constructor(props) {
    super(props)

    this.state = {
      sticky: false,
      shown: false
    }
  }

  render() {
    const classes: Array<string> = ['footer']

    return (
      <footer id="a11y-footer" className={classes.join(' ')}>
        {this.props.children}
      </footer>
    )
  }
}

const socialMediaLink = (lang: string, socialName: string, url: string) => {
  if (getLangFromHost() == lang) {
    return (
      <a
        className={`footer__social-link footer__social-link--${socialName}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer" />
    )
  }
}
